import { api } from "../../api/api";
import {
  GET_TEMPLATES_REQUEST,
  GET_TEMPLATES_SUCCESS,
  GET_TEMPLATES_FAILED,
} from "../constant";

/**
 * Fetches templates (layouts) using existing getcontent API with type=template.
 * Backend: GET /content/getcontent/:userId?page=1&limit=10&type=template&search=
 */
export const getTemplates = (userId, options = {}) => {
  return async (dispatch) => {
    dispatch({ type: GET_TEMPLATES_REQUEST, payload: "" });

    const { page = 1, limit = 10, search } = options;
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      type: "template",
      ...(search && { search }),
    });

    try {
      const res = await api.get(`/content/getcontent/${userId}?${params}`);

      if (res.status === 200) {
        const data = res.data;
        const content = data.content ?? data.templates ?? [];
        const pagination = data.pagination ?? {};

        dispatch({
          type: GET_TEMPLATES_SUCCESS,
          payload: {
            content: Array.isArray(content) ? content : [],
            pagination: {
              currentPage: pagination.currentPage ?? page,
              totalPages: pagination.totalPages ?? 1,
              totalItems: pagination.totalItems ?? 0,
              itemsPerPage: pagination.itemsPerPage ?? limit,
            },
          },
        });
      } else {
        dispatch({ type: GET_TEMPLATES_FAILED, payload: res.data || "Failed" });
      }
    } catch (error) {
      dispatch({
        type: GET_TEMPLATES_FAILED,
        payload: error.response?.data || error.message,
      });
    }
  };
};
